import type { Thing, WithContext } from 'schema-dts';

import { JsonLd } from 'react-schemaorg';

import type { EpiEcommercePageType } from '../../../../episerver/components/pages/EpiEcommercePage/epiEcommercePageType';

import { PageHeading } from '../../../../common/components/Heading/Heading';
import PageProperties from '../../../../common/components/molecules/PageProperties';
import EpiContentArea from '../../../../episerver/components/base/EpiContentArea';
import { useCurrentEpiPage } from '../../../../episerver/components/hooks/useCurrentEpiPage';
import { mapEpiPageHeadData } from '../../../../episerver/epiUtils';
import { organizationJsonLd } from '../../JsonLd/OrganizationJsonSchema';

const EcommercePage = () => {
    const currentPage = useCurrentEpiPage<EpiEcommercePageType>({
        depth: 5,
    });

    return (
        <>
            {/* MergeLeafTypes multi-@type is not assignable to Thing in schema-dts. */}
            <JsonLd<Thing> item={organizationJsonLd as unknown as WithContext<Thing>} />
            {currentPage.data && (
                <PageProperties
                    headData={mapEpiPageHeadData(currentPage.data)}
                    pageTypeNameForAnalytics={currentPage.data.pageTypeNameForAnalytics}
                />
            )}
            {currentPage.data && (
                <PageHeading alignment="start">{currentPage.data.headline}</PageHeading>
            )}
            {currentPage.data && (
                <div className="Grid Grid--gutterV Grid--gutterH2xsm">
                    <EpiContentArea items={currentPage.data.blocks} />
                </div>
            )}
        </>
    );
};

export default EcommercePage;
